import { render, staticRenderFns } from "./HadirKajian.vue?vue&type=template&id=01053a46&scoped=true&"
import script from "./HadirKajian.vue?vue&type=script&lang=js&"
export * from "./HadirKajian.vue?vue&type=script&lang=js&"
import style0 from "./HadirKajian.vue?vue&type=style&index=0&id=01053a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01053a46",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QBtn,QRadio});
